import Browser from '../../Browser'
import * as THREE from 'three'
var MAX_FOV = 100,
    MIN_FOV = 8,
    noop = function() {}
import $ from 'jquery'
import { allowedZooms } from './constants'

const EquiPanorama = require('./EquiPano.js').default
const EquirectangularPanorama = require('./EquirectangularPano.js').default
const EasyPanorama = require('./EasyPano.js').default
const WebglPanorama = require('./WebglPano.js').default
const CubePanorama = require('./CubePano.js').default

export const panoramas = {
    equi: EquiPanorama,
    easy: EasyPanorama,
    webgl: WebglPanorama,
    cube: CubePanorama,
}

export const types = {
    EASY: 'easy',
    WEBGL: 'webgl',
    CSS3D: 'css3d',
    CANVAS: 'canvas',
    FLASH: 'flash',
    CUBE: 'cube',
    EQUIRECTANGULAR: 'equirectangular',
}

let eventEmitter

export const getEventEmitter = () => {
    return eventEmitter
}

//polyfill for IE < 9
if (!Object.create) {
    Object.create = (function() {
        function F() {}

        return function(o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.')
            }
            F.prototype = o
            return new F()
        }
    })()
}

export function fireEvent(eventName, player) {
    eventEmitter.emit(eventName, null)
}

export function originCacheBuster(path) {
    //adds the protocol to protect against different origins being sent
    //and a daily timestamp in case it gets corrupted (ie a request with no origin is sent)
    return path + '?' + encodeURIComponent(window.location.protocol.replace(':', '')) + new Date().getUTCDay()
}

/**
 * Draws a rounded rectangle using the current state of the canvas.
 * If you omit the last three params, it will draw a rectangle
 * outline with a 5 pixel border radius
 * @param {CanvasRenderingContext2D} ctx
 * @param {Number} x The top left x coordinate
 * @param {Number} y The top left y coordinate
 * @param {Number} width The width of the rectangle
 * @param {Number} height The height of the rectangle
 * @param {Number} [radius = 5] The corner radius; It can also be an object
 *                 to specify different radii for corners
 * @param {Number} [radius.tl = 0] Top left
 * @param {Number} [radius.tr = 0] Top right
 * @param {Number} [radius.br = 0] Bottom right
 * @param {Number} [radius.bl = 0] Bottom left
 * @param {Boolean} [fill = false] Whether to fill the rectangle.
 * @param {Boolean} [stroke = true] Whether to stroke the rectangle.
 */
CanvasRenderingContext2D.prototype.roundRect = function(x, y, width, height, radius) {
    if (!radius) {
        radius = Math.min(width, height) / 2
    }
    if (typeof radius === 'number') {
        radius = {
            tl: radius,
            tr: radius,
            bl: radius,
            br: radius,
        }
    }
    this.beginPath()
    //upper right
    this.moveTo(x + width - radius.tr, y)
    this.quadraticCurveTo(x + width, y, x + width, y + radius.tr)
    //bottom right
    this.lineTo(x + width, y + height - radius.br)
    this.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height)
    //bottom left
    this.lineTo(x + radius.bl, y + height)
    this.quadraticCurveTo(x, y + height, x, y + height - radius.bl)
    //upper left
    this.lineTo(x, y + radius.tl)
    this.quadraticCurveTo(x, y, x + radius.tl, y)
    this.closePath()
}

window.EventHandler = function(self) {
    this.events = {}
    this.self = self
}

EventHandler.prototype.add = function(name, call) {
    var list = this.events[name] || []
    list.push(call)
    this.events[name] = list
}

EventHandler.prototype.remove = function(name, call) {
    var list = this.events[name] || []
    if (call) {
        var index = list.indexOf(call)
        if (index != -1) {
            list.splice(index, 1)
        }
    } else {
        list = []
    }
    this.events[name] = list
}

EventHandler.prototype.call = function(name, args) {
    var list = this.events[name] || [],
        ret
    for (var i = 0; i < list.length; i++) {
        ret = list[i].apply(this.self, args)
    }
    return ret
}

THREE.Scene.prototype.call = THREE.Object3D.prototype.call = function(name, args) {
    return this.event ? this.event.call(name, args) : null
}

THREE.Scene.prototype.addEvent = THREE.Object3D.prototype.addEvent = function(name, callback) {
    this.event = this.event || new EventHandler(this)
    this.event.add(name, callback)
}

THREE.Scene.prototype.removeEvent = THREE.Object3D.prototype.removeEvent = function(name, callback) {
    this.event = this.event || new EventHandler(this)
    this.event.remove(name, callback)
}

THREE.Scene.prototype.draw = function(d) {
    this.call('draw', [d])
}

/*                                                                                                                                                                           
PPPPPPPPPPPPPPPPP                                                     PPPPPPPPPPPPPPPPP   lllllll                                                                              
P::::::::::::::::P                                                    P::::::::::::::::P  l:::::l                                                                              
P::::::PPPPPP:::::P                                                   P::::::PPPPPP:::::P l:::::l                                                                              
PP:::::P     P:::::P                                                  PP:::::P     P:::::Pl:::::l                                                                              
  P::::P     P:::::Paaaaaaaaaaaaa  nnnn  nnnnnnnn       ooooooooooo     P::::P     P:::::P l::::l   aaaaaaaaaaaaayyyyyyy           yyyyyyy eeeeeeeeeeee    rrrrr   rrrrrrrrr   
  P::::P     P:::::Pa::::::::::::a n:::nn::::::::nn   oo:::::::::::oo   P::::P     P:::::P l::::l   a::::::::::::ay:::::y         y:::::yee::::::::::::ee  r::::rrr:::::::::r  
  P::::PPPPPP:::::P aaaaaaaaa:::::an::::::::::::::nn o:::::::::::::::o  P::::PPPPPP:::::P  l::::l   aaaaaaaaa:::::ay:::::y       y:::::ye::::::eeeee:::::eer:::::::::::::::::r 
  P:::::::::::::PP           a::::ann:::::::::::::::no:::::ooooo:::::o  P:::::::::::::PP   l::::l            a::::a y:::::y     y:::::ye::::::e     e:::::err::::::rrrrr::::::r
  P::::PPPPPPPPP      aaaaaaa:::::a  n:::::nnnn:::::no::::o     o::::o  P::::PPPPPPPPP     l::::l     aaaaaaa:::::a  y:::::y   y:::::y e:::::::eeeee::::::e r:::::r     r:::::r
  P::::P            aa::::::::::::a  n::::n    n::::no::::o     o::::o  P::::P             l::::l   aa::::::::::::a   y:::::y y:::::y  e:::::::::::::::::e  r:::::r     rrrrrrr
  P::::P           a::::aaaa::::::a  n::::n    n::::no::::o     o::::o  P::::P             l::::l  a::::aaaa::::::a    y:::::y:::::y   e::::::eeeeeeeeeee   r:::::r            
  P::::P          a::::a    a:::::a  n::::n    n::::no::::o     o::::o  P::::P             l::::l a::::a    a:::::a     y:::::::::y    e:::::::e            r:::::r            
PP::::::PP        a::::a    a:::::a  n::::n    n::::no:::::ooooo:::::oPP::::::PP          l::::::la::::a    a:::::a      y:::::::y     e::::::::e           r:::::r            
P::::::::P        a:::::aaaa::::::a  n::::n    n::::no:::::::::::::::oP::::::::P          l::::::la:::::aaaa::::::a       y:::::y       e::::::::eeeeeeee   r:::::r            
P::::::::P         a::::::::::aa:::a n::::n    n::::n oo:::::::::::oo P::::::::P          l::::::l a::::::::::aa:::a     y:::::y         ee:::::::::::::e   r:::::r            
PPPPPPPPPP          aaaaaaaaaa  aaaa nnnnnn    nnnnnn   ooooooooooo   PPPPPPPPPP          llllllll  aaaaaaaaaa  aaaa    y:::::y            eeeeeeeeeeeeee   rrrrrrr            
                                                                                                                       y:::::y                                                 
                                                                                                                      y:::::y                                                  
                                                                                                                     y:::::y                                                   
                                                                                                                    y:::::y                                                    
                                                                                                                   yyyyyyy                                                     
                                                                                                                                                                        
*/

var PanoPlayer =
    window.PanoPlayer ||
    function(options) {
        //setup vars

        //zooms: the total width of the resultant image
        //height will be width/2. ofr cube width = 4*tileSize
        this.zoomLevels = [512, 1024, 2048, 3072, 4096, 6144]
        this.zoom = undefined
        this.defaults = {
            rotation: 0,
            showRotate: true,
            showFullscreen: true,
            autoRotate: false,
            autoRotateSpeed: 0.3,
            maxAngle: { h: 360, v: 89.9 },
            minAngle: { h: -360, v: -90 },
            startLon: 180,
            startLat: 0,
            startFov: null,
            hasEasy: false,
            width: null,
            height: null,
            title: null,
            showHint: true,
            hintTimeout: 5000,
            hintPosition: {
                top: '40%',
                left: '50%',
            },
            viewPercent: 0.35,
            businessCard: null,
            depthMarkers: null,
            localMode: null,
            accelerometerControls: false,
        }

        //brower - pano type map
        this.defaultTypeMap = [
            PanoPlayer.types.EASY,
            PanoPlayer.types.WEBGL,
            PanoPlayer.types.CSS3D,
            PanoPlayer.types.CANVAS,
            PanoPlayer.types.FLASH,
            PanoPlayer.types.EQUIRECTANGULAR,
        ]

        this.panoramas = {
            equi: EquiPanorama,
            easy: EasyPanorama,
            equirectangular: EquirectangularPanorama,
            webgl: WebglPanorama,
            cube: CubePanorama,
        }

        //browsers checked in order so more specific first
        this.typeMap = {
            mobile: [PanoPlayer.types.EASY, PanoPlayer.types.WEBGL],
            chrome: this.defaultTypeMap,
            firefox: this.defaultTypeMap,
            safari: [PanoPlayer.types.EASY, PanoPlayer.types.WEBGL, PanoPlayer.types.CSS3D, PanoPlayer.types.FLASH],
            ie11: [PanoPlayer.types.EASY, PanoPlayer.types.WEBGL, PanoPlayer.types.FLASH, PanoPlayer.types.CANVAS],
            ie: [PanoPlayer.types.FLASH, PanoPlayer.types.CANVAS],
        }

        this.buttonSize = 40

        this.viewReadyFired = false

        this.creationDimensions = {
            height: 0,
            width: 0,
        }

        var type

        this.getType = () => {
            if (this.options.localMode) {
                return 'equi'
            }

            var types = this.defaultTypeMap,
                type
            for (var browser in this.typeMap) {
                if (Browser.is(browser)) {
                    types = this.typeMap[browser]
                    break
                }
            }

            for (type in types) {
                //See if easy is an option
                if (types[type] == PanoPlayer.types.EASY && this.options.hasEasy != true) {
                    continue
                }

                if (Browser.can(types[type])) {
                    break
                }
            }

            return types[type]
        }

        this.getFov = () => {
            if (typeof this.panorama !== 'undefined' && typeof this.panorama.camera !== 'undefined') {
                return this.panorama.camera._camera.fov
            }
            return null
        }

        /**
         * Calculates the starting field-of-view from a percentage of the
         * panorama that should be visible on first load
         *
         * This option is passed in to allow calculating of starting FOV
         * independent of the options passed in
         *
         * @param {Number} viewPercent A number such 0 < viewPercent <= 1
         *                             representing the percentage of the view
         */

        this.calculateStartFov = viewPercent => {
            var views = 1 / viewPercent + (this.viewerWidth > this.viewerHeight ? 0 : 1.0), //for screens with an odd orientation show extra view
                distance = this.viewerWidth

            return (
                2 * Math.atan((this.viewerHeight / distance) * Math.tan((2 * Math.PI) / (views * 2))) * (180 / Math.PI)
            )
        }

        this.getStartFov = () => {
            var unbounded = this.options.startFov || this.calculateStartFov(this.options.viewPercent)

            return Math.max(Math.min(unbounded, MAX_FOV), MIN_FOV)
        }

        this.calculateZoom = allowedZooms => {
            var zoom,
                multiplyer = this.isMobile ? 1.8 : 1.1,
                fov = this.getFov() || this.getStartFov() || 100,
                vfovRad = (fov * Math.PI) / 180,
                hfovRad = 2 * Math.atan((Math.tan(vfovRad / 2) * this.viewerWidth) / this.viewerHeight),
                hfov = Math.ceil((hfovRad * 180) / Math.PI),
                minPanoWidth = (this.viewerWidth / hfov) * 360 * multiplyer

            for (var z in allowedZooms) {
                zoom = allowedZooms[z]
                if (minPanoWidth < this.zoomLevels[zoom]) break
            }

            if (this.isMobile && zoom > 4) {
                zoom = 4
            }
            return zoom
        }

        this.getPanoWidth = () => {
            return this.zoomLevels[this.zoom]
        }

        this.parsePath = path => {
            this.path = path
            var pos = this.path.lastIndexOf('/')
            // Remove any slashes at the end of the URL
            if (pos == this.path.length - 1) {
                this.basePath = this.path.substring(0, pos)
            } else {
                this.basePath = this.path
            }
            pos = this.basePath.lastIndexOf('/')
            var panoId = this.basePath.substring(pos + 1)
            this.basePath = this.basePath.substring(0, pos)
            return panoId
        }

        //clone the defaults object so its values arent overwritten
        this.options = Object.create(this.defaults)

        for (var name in options) {
            if (options[name] !== null && typeof options[name] != 'undefined') this.options[name] = options[name]
        }

        if (!this.options.localMode) {
            if (options.path != undefined) {
                this.panoId = this.parsePath(options.path)
            } else {
                this.panoId = this.options.panoId
                this.basePath = this.options.basePath
            }

            if (this.panoId === undefined || this.basePath === undefined) {
                throw {
                    name: 'InvalidUsage',
                    message: 'Cannot create a panorama without a pano ID and basePath set',
                }
            }

            //ensure basepath has closing slash
            if (this.basePath[this.basePath.length - 1] != '/') {
                this.basePath += '/'
            }
        }

        this.elem =
            typeof this.options.selector === 'string'
                ? $('#' + this.options.selector, document)[0]
                : this.options.selector

        if (!this.elem) {
            throw {
                name: 'InvalidUsage',
                message: 'An existing element must be used to embed the panorama',
            }
        }

        this.autoRotate = this.options.autoRotate
        this.autoRotateSpeed = this.options.autoRotateSpeed
        this.showHint = this.options.showHint
        this.fullscreen = false

        this.viewerWidth = this.options.width || this.elem.clientWidth || window.innerWidth
        this.viewerHeight = this.options.height || this.elem.clientHeight || window.innerHeight

        eventEmitter = this.options.eventEmitter

        if (+this.viewerWidth != this.viewerWidth) {
            if (this.viewerWidth[this.viewerWidth.length - 1] != '%') {
                throw {
                    name: 'InvalidUsage',
                    message: 'Invalid string passed for width',
                }
            }

            var percent = this.viewerWidth.substring(0, this.viewerWidth.length - 1) / 100
            this.viewerWidth = percent * (this.elem.clientWidth || window.innerWidth)
        }

        if (+this.viewerHeight != this.viewerHeight) {
            if (this.viewerHeight[this.viewerHeight.length - 1] != '%') {
                throw {
                    name: 'InvalidUsage',
                    message: 'Invalid string passed for height',
                }
            }

            var percent = this.viewerHeight.substring(0, this.viewerHeight.length - 1) / 100
            this.viewerHeight = percent * (this.elem.clientHeight || window.innerHeight)
            this.creationDimensions.width = this.viewerWidth
            this.creationDimensions.height = this.viewerHeight
        }

        this.autoResize = this.options.autoResize || false
        this.fullWindow = this.viewerWidth == window.innerWidth && this.viewerHeight == window.innerHeight

        this.type = options.type || this.getType()
        this.zoom = this.calculateZoom(allowedZooms[this.type])
        this.panorama = new this.panoramas[this.type](this)

        this.embed = () => {
            var _this = this
            if (this.loading) {
                setTimeout(this.embed.bind(this), 100)
                return this
            }

            this.elem.innerHTML = ''
            this.elem.appendChild(this.panorama.element)

            this.panorama.setSize(this.viewerWidth, this.viewerHeight)
            if (this.fullWindow || this.autoResize) {
                window.addEventListener('resize', this, false)
            }

            this.panorama.embed()

            return this
        }
        // this.eventEmitter = new EventEmitter()

        this.isMobile = Browser.is('mobile')

        // this.getTileUrl = (panoPath, type, size, coord) => {
        //     // return Panorama.getTileUrl(panoPath, type, size, coord)
        //     return Panorama.getTileUrl(this.zoom)
        // }
        ;(this.on = (name, cb) => {
            eventEmitter.on(name, cb)
            return this
        }),
            (this.off = (name, cb) => {
                if (cb) {
                    eventEmitter.off(name, cb)
                } else {
                    eventEmitter.removeEvent(name)
                }
                return this
            }),
            (this.destroy = options => {
                var causedBySwap = typeof options !== 'undefined' && options.causedBySwap
                window.removeEventListener('resize', this)
                document.removeEventListener('fullscreenchange', this)
                document.removeEventListener('mozfullscreenchange', this)
                document.removeEventListener('webkitfullscreenchange', this)

                eventEmitter.emit('destroy', null)
                eventEmitter.removeAllListeners()

                this.panorama && this.panorama.destroy()
                delete this.panorama
            }),
            (this.handleEvent = event => {
                if (event.type == 'resize') {
                    var width = window.innerWidth
                    var height = window.innerHeight
                    if (!this.fullWindow && !this.fullscreen) {
                        width = $(this.elem)
                            .parent()
                            .innerWidth()
                        height = $(this.elem)
                            .parent()
                            .innerHeight()
                    }
                    if (width > 0 && height > 0) this.setSize(width, height)
                }

                if (
                    event.type.indexOf('fullscreenchange') != -1 &&
                    ((document.fullScreenElement && document.fullScreenElement !== null) ||
                        (!document.mozFullScreen && !document.webkitIsFullScreen))
                ) {
                    this.setFullscreen(false)
                }
            })

        /**
         * This will update the panorama with a new panorama
         * @param {object|int} pano The ID of the new panorama or the data object containing its info
         */

        this.setSource = pano => {
            var panoId

            if (typeof pano == 'object') {
                if (!pano.id && pano.path) {
                    panoId = this.parsePath(pano.path)
                } else {
                    panoId = pano.id
                }

                if (this.panorama.camera) {
                    this.panorama.camera.getCamera().fov =
                        typeof pano.start_fov != 'undefined'
                            ? pano.start_fov
                            : this.calculateStartFov(this.defaults.viewPercent)
                    this.panorama.camera.lon = Number(
                        typeof pano.start_lon != 'undefined' ? pano.start_lon : this.defaults.startLon
                    )
                    this.panorama.camera.lat = Number(
                        typeof pano.start_lat != 'undefined' ? pano.start_lat : this.defaults.startLat
                    )
                    this.panorama.camera.refreshView()
                    this.panorama.camera.refreshZoom()
                }
            } else {
                panoId = pano
            }

            this.viewReadyFired = false

            if (this.panoId != panoId) {
                this.panoId = panoId
                this.panorama.regenerateTextures()
            }
        }

        this.setSize = (width, height) => {
            this.viewerWidth = width
            this.viewerHeight = height
            this.panorama.setSize(width, height)

            var oldZoom = this.zoom
            // this.zoom = this.calculateZoom(PanoPlayer.panoramas[this.type].allowedZooms)
            this.zoom = this.calculateZoom(allowedZooms[this.type])

            if (oldZoom < this.zoom) {
                this.panorama.regenerateTextures()
            }
        }

        this.getPanoWidth = () => {
            return this.zoomLevels[this.zoom]
        }

        this.getPanoHeight = () => {
            return this.getPanoWidth() / 2
        }

        this.getStartLon = () => {
            return +this.options.startLon
        }

        this.getStartLat = () => {
            return +this.options.startLat
        }

        this.getLat = () => {
            if (typeof this.panorama !== 'undefined' && typeof this.panorama.camera !== 'undefined') {
                return this.panorama.camera.lat
            }
            return null
        }

        this.getLon = () => {
            if (typeof this.panorama !== 'undefined' && typeof this.panorama.camera !== 'undefined') {
                return this.panorama.camera.lon
            }
            return null
        }

        /**
         * forceZoomOut()
         *
         * Running this function test, whether the current size of the pano player is
         * larger then the size of the pano player on its createion.
         * If this is true it will forcible zoom out the player, since this case cause the
         * panorama to be zoomed in very closes, and looks bad.
         * Other wise it does nothing
         *
         * @return PanoPlayer, instace of
         */
        this.forceZoomOut = () => {
            var newWidth = this.elem.clientWidth || window.innerWidth,
                newHeight = this.elem.clientHeight || window.innerHeight

            if (newWidth > this.creationDimensions.width || newHeight > this.creationDimensions.height) {
                this.panorama.camera.zoom(-120)
            }
            return this
        }

        /**
         * rotate the panorama to the desired position. The function can set angle immediately or incremental
         * based on a time limit or a speed
         *
         * @param position       {lat, lon, fov}
         * @param optionss       {speed (degrees per second), duration (milliseconds), callback}
         *
         * Set either speed or duration.
         */
        this.setPosition = (position, options) => {
            if (typeof this.panorama !== 'undefined' && typeof this.panorama.camera !== 'undefined') {
                this.panorama.camera.setAbsolutePosition(position, options)
            }
        }

        this.getCameraOptions = () => {
            return {
                maxAngle: this.options.maxAngle,
                minAngle: this.options.minAngle,
                fov: this.getStartFov(),
                maxFov: MAX_FOV,
                minFov: MIN_FOV,
                startLon: this.getStartLon(),
                startLat: this.getStartLat(),
                height: this.viewerHeight,
                width: this.viewerWidth,
                autoRotate: this.autoRotate,
                autoRotateSpeed: this.autoRotateSpeed,
                accelerometerControls: this.options.accelerometerControls,
            }
        }

        this.setLoading = loading => {
            this.loading = loading
        }

        this.setFullscreen = on => {
            if (on) {
                var fse =
                    document.fullscreenElement ||
                    document.mozFullScreenElement ||
                    document.webkitFullscreenElement ||
                    document.msFullscreenElement

                if (fse) {
                    return
                }

                if (this.elem.requestFullscreen) {
                    this.elem.requestFullscreen()
                } else if (this.elem.mozRequestFullScreen) {
                    this.elem.mozRequestFullScreen()
                } else if (this.elem.webkitRequestFullscreen) {
                    this.elem.webkitRequestFullscreen()
                }

                this.oldWidth = this.viewerWidth
                this.oldHeight = this.viewerHeight
                this.setSize(screen.width, screen.height)
                this.fullscreen = on
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                }
                this.setSize(this.oldWidth, this.oldHeight)
                this.fullscreen = on
            }
        }

        this.setAutoRotate = (on, autoRotateSpeed) => {
            if (typeof this.panorama !== 'undefined' && typeof this.panorama.camera !== 'undefined') {
                this.autoRotate = !this.panorama.camera.isDisabled() && on
                if (on) {
                    this.autoRotateSpeed = autoRotateSpeed
                }
                this.panorama.setAutoRotate(this.autoRotate, autoRotateSpeed)
            }
        }

        this.requestUpdate = () => {
            if (typeof this.panorama !== 'undefined') {
                this.panorama.needsRefresh = true
            }
        }

        this.requestUpdate = () => {
            if (typeof this.panorama !== 'undefined') {
                this.panorama.needsRefresh = true
            }
        }
        return this
    }

PanoPlayer.types = {
    EASY: 'easy',
    WEBGL: 'webgl',
    CSS3D: 'css3d',
    CANVAS: 'canvas',
    FLASH: 'flash',
    CUBE: 'cube',
    EQUIRECTANGULAR: 'equirectangular',
}

PanoPlayer.panoramas = panoramas

export default PanoPlayer
